import React from 'react';
import { Helmet } from 'react-helmet';
import ServicePage from '../components/ServicePage';
import html from '../content/aiPolicyDevelopment.html.js';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function AIPolicyDevelopment() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'AI Policy Development Service',
    description:
      'Establishing robust, ethical and compliant AI governance frameworks tailored to your organisation.',
    url: canonicalUrl,
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>AI Policy Development</title>
        <meta name="description" content="Build ethical and compliant AI governance tailored to your organisation." />
        <meta property="og:title" content="AI Policy Development" />
        <meta property="og:description" content="Establish a robust framework for responsible AI use." />
        <meta property="og:image" content="/assets/visuals/re-profile-blue-ai-hud.webp" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <ServicePage
        title="AI Policy Development"
        tagline="Establishing robust, ethical and compliant AI governance frameworks tailored to your organisation."
        ctaText="Contact Us"
        ctaLink="/contact"
        htmlContent={html}
        imageSrc="/assets/visuals/re-profile-blue-ai-hud.webp"
        imageAlt="AI policy development visual"
      />
    </>
  );
}
